import BaseResource from './index'
import UserResource from './user'
import EntityResource from './entities'
import validators from '../utilities/validation'

function validateRoleId(value, instance, ValidationError) {
    try {
        validators.isNonEmpty(value, instance, ValidationError)
    } catch (validationError) {
        validationError.field = 'Role Id'
        throw validationError + '(' + validationError.field + ')'
    }
}

export default class UserRolesMxResource extends BaseResource {
    static endpoint = '/oasis/restv3/admin/userroles'

    static related = {
        user_id: UserResource,
        entity_id: EntityResource,
    }

    static validation = {
        role_id: validateRoleId,
    }
}
